/**
 * NotFoundPage — 404
 */
import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <div className="sandvik-container py-16 text-center">
      <h1 className="font-sandvik-headline font-normal text-6xl text-sandvik-gold mb-4">404</h1>
      <p className="text-n5 text-lg mb-8">Page not found</p>
      <Link to="/" className="btn-primary inline-block">Back to Home</Link>
    </div>
  );
}
